<div class="related-inf-item-container">
    <div *ngIf="!placeholderMode" class="inf-name-container">
        <div>{{influencer.name}}</div>
    </div>

    <div class="inf-images-container">
        <ng-container *ngIf="!placeholderMode">
            <a [routerLink]="influencerlink" [queryParams]="influencerlinkParams" target="_blank" class="inf-avatar">
                <img src='{{userAvatarPicture}}' (error)="resolveNoAvatarUrl()" />
            </a>
    
            <div class="inf-flag">
                <div *ngIf="influencer.country?.code" class="flag-icon-{{influencer.country.code.toLowerCase()}}"></div>
                <div *ngIf="!influencer.country?.code" class="flag-icon-inter flag-icon-squared"></div>
            </div>
        </ng-container>

        <div *ngIf="placeholderMode" class="inf-avatar">
            <img src='{{placeholderAvatar}}'/>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/related-influencers/related-influencer-item/related-influencer-item.component.html